module.exports = __webpack_public_path__ + "static/media/img_4.dc0a6040.png";